export default __webpack_public_path__ + "static/media/SphereSubspaces.b72b216c.webp";